/* eslint-disable no-return-assign,no-prototype-builtins */

/**
 * The only reason to add this polyfill is this issue:
 * "Failed to read the 'localStorage' property from 'Window': Access is denied for this document."
 */

(function setup(isStorage) {
	if (!isStorage) {
		const items = new Map();
		class LocalStorage {
			getItem(key) {
				const stringKey = String(key);
				if (items.has(key)) {
					return String(items.get(stringKey));
				}
				return null;
			}
			setItem(key, val) {
				console.info('localStorage.setItem', key, val);
				items.set(String(key), String(val));
			}
			removeItem(key) {
				items.delete(key);
			}
			clear() {
				items.clear();
			}
			key(i) {
				if (arguments.length === 0) {
					throw new TypeError(
						"Failed to execute 'key' on 'Storage': 1 argument required, but only 0 present."
					); // this is a TypeError implemented on Chrome, Firefox throws Not enough arguments to Storage.key.
				}
				const arr = Array.from(items.keys());
				return arr[i];
			}
			get length() {
				return items.size;
			}
		}
		Object.defineProperty(window, 'localStorage', {
			value: new LocalStorage(),
			configurable: true,
			enumerable: true,
			writable: false,
		});
	}
})(
	(function check() {
		try {
			return 'localStorage' in window && window.localStorage != null;
		} catch (e) {
			return false;
		}
	})()
);
